import React from "react";
import {
  Box,
  Stack,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CustomChip from "../components/custom_chip.component";

function ListTile({
  caseId,
  caseNumber,
  status,
  category,
  topic,
  issue,
  date,
}) {
  const userapi = useSelector((state) => state.userapi);

  return (
    <List sx={{ paddingTop: 0, paddingBottom: 0 }}>
      <Link
        to={`/incident_detail_page/${caseId}`}
        style={{ textDecoration: "none" }}
      >
        <ListItem disablePadding>
          <ListItemButton sx={{ paddingTop: "16px", paddingBottom: "16px" }}>
            <Stack width="100%">
              <Box
                sx={{ display: "flex" }}
                onClick={() =>
                  ReactGA.gtag("event", "Tap Case Item", {
                    caseId,
                    sessionIdCustom: userapi.sessionID,
                    userId: userapi.userSysId,
                    orgID: !userapi.orgId ? 0 : userapi.orgId,
                    agency: userapi.agency,
                    channel: "Mobile",
                    timestamp: Date(),
                  })
                }
              >
                <ListItemText
                  primary={date}
                  primaryTypographyProps={{
                    color: "#4D4D4D",
                    fontFamily: "Open Sans",
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "14px",
                    textDecoration: "none",
                    lineHeight: "20px",
                  }}
                />
                <CustomChip status={status} />
              </Box>
              <ListItemText
                primary={caseNumber}
                primaryTypographyProps={{
                  color: "#4D4D4D",
                  fontFamily: "Open Sans",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: "16px",
                  textDecoration: "none",
                  lineHeight: "20px",
                }}
              />
              <ListItemText
                secondary={`${topic} ${topic === "" ? "" : ">"} ${issue}`}
                secondaryTypographyProps={{
                  color: "#4D4D4D",
                  fontFamily: "Open Sans",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "20px",
                }}
              />
            </Stack>
          </ListItemButton>
        </ListItem>
        <Divider
          style={{
            background: "#D0D0D0",
            borderBottomWidth: "1px",
            borderColor: "rgba(0, 0, 0, 1)",
          }}
        />
      </Link>
    </List>
  );
}

export default ListTile;
